import { defaultColors } from "src/app/classes/widget/chartHandlerV2";

let defaultColorsObj: { [key: number]: any } = {};
defaultColors.forEach((c, i) => {
    defaultColorsObj[i] = c;
});

export let designInputs = {
    block: [
        {
            label: 'editor.colors',
            name: 'colors',
            icon: 'color_lens',
            options: [
                // {
                //     type: "checkbox",
                //     label: "Color by label",
                //     default: true,
                //     name: "colorByLabel"
                // },
                // Empty: the theme colors.
                {
                    type: 'color',
                    label: 'editor.background',
                    default: '',
                    auto: true,
                    width: '140px',
                    name: 'backgroundColor',
                },
                {
                    type: 'color',
                    label: 'editor.string',
                    default: '',
                    auto: true,
                    width: '100%',
                    name: 'textColor',
                },
                // The bar on the left of the tile: the theme color, the alert one under conditional formatting.
                {
                    type: 'checkbox',
                    label: 'editor.accent',
                    default: true,
                    width: '100%',
                    name: 'accent',
                    group: 'accent',
                    groupKey: true,
                },
                {
                    type: 'color',
                    label: 'editor.accent_color',
                    default: '',
                    auto: true,
                    width: '100%',
                    name: 'accentColor',
                    group: 'accent',
                },
                {
                    type: 'checkbox',
                    label: 'editor.conditional_formatting',
                    default: false,
                    width: '100%',
                    name: 'conditionalFormatting',
                    group: 'altColor',
                    groupKey: true,
                },
                {
                    type: 'select',
                    label: 'Type',
                    default: 'Number',
                    name: 'type',
                    width: '100%',
                    options: [
                        { name: 'form.number', value: 'Number', icon: 'format_list_numbered' },
                        { name: 'form.date', value: 'Date', icon: 'date_range' },
                        { name: 'dashboard.filter.period', value: 'Period', icon: 'schedule' },
                    ],
                    group: 'altColor',
                    subgroup: 'altColorType',
                    subgroupKey: true,
                },
                {
                    type: 'select',
                    label: 'editor.operator',
                    default: 'Greater than or equal to',
                    name: 'operator',
                    width: '100%',
                    options: [
                        { name: 'editor.equalTo', value: 'Equal to', icon: 'drag_handle' },
                        { name: 'editor.notEqualTo', value: 'Not equal to', icon: 'not_equal' },
                        { name: 'editor.greaterThan', value: 'Greater than', icon: 'keyboard_arrow_right' },
                        {
                            name: 'editor.greaterThanOrEqualTo',
                            value: 'Greater than or equal to',
                            icon: 'keyboard_double_arrow_right'
                        },
                        { name: 'editor.lessThan', value: 'Less than', icon: 'keyboard_arrow_left' },
                        {
                            name: 'editor.lessThanOrEqualTo',
                            value: 'Less than or equal to',
                            icon: 'keyboard_double_arrow_left'
                        },
                    ],
                    group: 'altColor',
                    subgroup: 'altColorType',
                    subgroupOptions: ['Number', 'Date', 'Period'],
                    subgroupWidth: { number: '100%', date: '180px', period: '230px' },
                },
                {
                    type: 'number',
                    label: 'editor.y',
                    name: 'value',
                    default: 0,
                    width: '85px',
                    group: 'altColor',
                    subgroup: 'altColorType',
                    subgroupOptions: ['Number'],
                },
                {
                    type: 'datetime-local',
                    label: 'Date',
                    class: 'limit',
                    toggle: 'Range',
                    name: 'date',
                    default: new Date(Date.now() - 24 * 60 * 60 * 1000),
                    group: 'altColor',
                    width: '140px',
                    subgroup: 'altColorType',
                    subgroupOptions: ['Date'],
                },
                {
                    type: 'number',
                    label: 'editor.period_amount',
                    class: 'limit',
                    name: 'periodAmount',
                    toggle: 'Period',
                    group: 'altColor',
                    default: 1,
                    width: '120px',
                    subgroup: 'altColorType',
                    subgroupOptions: ['Period'],
                },
                {
                    type: 'select',
                    label: 'editor.periodValue',
                    name: 'periodValue',
                    default: 'day',
                    group: 'altColor',
                    width: '100%',
                    options: [
                        { name: 'date.year', value: 'year', icon: 'calendar_view_year' },
                        { name: 'date.month', value: 'month', icon: 'calendar_view_month' },
                        { name: 'date.week', value: 'week', icon: 'calendar_view_week' },
                        { name: 'date.day', value: 'day', icon: 'calendar_today' },
                        { name: 'date.hour', value: 'hour', icon: 'schedule' },
                        { name: 'date.minute', value: 'minute', icon: 'access_time' },
                        { name: 'date.second', value: 'second', icon: 'timer' },
                    ],
                    subgroup: 'altColorType',
                    subgroupOptions: ['Period'],
                },
                {
                    type: 'color',
                    label: 'editor.background',
                    default: '',
                    auto: true,
                    width: '140px',
                    name: 'altBackgroundColor',
                    group: 'altColor',
                },
                {
                    type: 'color',
                    label: 'editor.string',
                    default: '#EF4444',
                    width: '100%',
                    name: 'altTextColor',
                    group: 'altColor',
                },
            ],
        },
        {
            label: 'editor.string',
            name: 'text',
            icon: 'format_shapes',
            options: [
                {
                    type: 'checkbox',
                    label: 'editor.displayText',
                    default: true,
                    width: '100%',
                    name: 'display',
                },
                {
                    type: 'number',
                    label: 'editor.title_font_size',
                    name: 'titleFontSize',
                    default: 14,
                    width: '100%',
                },
                {
                    type: 'select',
                    label: 'Position',
                    default: 'top',
                    name: 'position',
                    width: '100%',
                    options: [
                        { name: 'geometry.top', value: 'top', icon: 'keyboard_arrow_up' },
                        { name: 'geometry.bottom', value: 'bottom', icon: 'keyboard_arrow_down' },
                    ],
                },
                {
                    type: 'select',
                    label: 'editor.align',
                    default: 'center',
                    name: 'align',
                    width: '100%',
                    options: [
                        { name: 'events.start', value: 'start', icon: 'format_align_left' },
                        { name: 'editor.center', value: 'center', icon: 'format_align_center' },
                        { name: 'events.end', value: 'end', icon: 'format_align_right' },
                    ],
                },
                {
                    type: 'select',
                    label: 'Format',
                    default: 'text',
                    value: 'text',
                    name: 'format',
                    width: '100%',
                    options: [
                        { name: 'editor.string', value: 'text' },
                        { name: 'editor.number', value: 'number' },
                        { name: 'form.date', value: 'date' },
                        { name: 'editor.timing', value: 'timing' },
                    ],
                },
                {
                    type: 'number',
                    label: 'editor.font_size',
                    name: 'valueFontSize',
                    default: 40,
                    width: '100%',
                },
            ],
        },
    ],
    map: [
        {
            label: 'editor.title',
            name: 'title',
            icon: 'format_shapes',
            options: [
                {
                    type: 'checkbox',
                    label: 'datatable.display',
                    default: true,
                    name: 'display',
                },
                {
                    type: 'number',
                    label: 'editor.font_size',
                    name: 'fontSize',
                    default: 18,
                    width: '100%',
                },
                {
                    type: 'select',
                    label: 'editor.align',
                    default: 'center',
                    name: 'align',
                    width: '100%',
                    options: [
                        { name: 'events.start', value: 'start', icon: 'format_align_left' },
                        { name: 'editor.center', value: 'center', icon: 'format_align_center' },
                        { name: 'events.end', value: 'end', icon: 'format_align_right' },
                    ],
                },
            ],
        },
        {
            label: 'editor.colors',
            name: 'colors',
            icon: 'color_lens',
            options: [
                // {
                //     type: "checkbox",
                //     label: "Color by label",
                //     default: true,
                //     name: "colorByLabel"
                // },
                {
                    type: 'colors',
                    label: 'editor.color_list',
                    default: defaultColorsObj,
                    name: 'colorList',
                },
            ],
        },
        {
            label: 'viewer.maps',
            name: 'map',
            icon: 'map',
            options: [
                {
                    type: 'select',
                    label: 'editor.map_type',
                    default: 'roadmap',
                    name: 'mapType',
                    width: '100%',
                    options: [
                        { name: 'editor.roadmap', value: 'roadmap', icon: 'map' },
                        { name: 'Satellite', value: 'satellite', icon: 'satellite_alt' },
                        { name: 'editor.hybrid', value: 'hybrid', icon: 'layers' },
                    ],
                },
                {
                    type: 'number',
                    label: 'editor.point_opacity',
                    name: 'pointOpacity',
                    default: 0.5,
                    width: '100%',
                },
                {
                    type: 'number',
                    label: 'editor.point_radius',
                    name: 'pointRadius',
                    default: 10,
                    width: '100%',
                },
                {
                    type: 'checkbox',
                    label: 'editor.custom_coordinate',
                    default: false,
                    name: 'useCustomCoordinate',
                    width: '100%',
                },
                {
                    type: 'number',
                    label: 'editor.custom_lat',
                    name: 'customLat',
                    default: 48.85837,
                    width: '100%',
                },
                {
                    type: 'number',
                    label: 'editor.custom_lon',
                    name: 'customLon',
                    default: 2.294432,
                    width: '100%',
                },
                {
                    type: 'number',
                    label: 'editor.custom_zoom',
                    name: 'customZoom',
                    default: 19,
                    width: '100%',
                },
                {
                    type: 'select',
                    label: 'editor.model_use',
                    default: '',
                    name: 'modelList',
                    width: '100%',
                    options: [],
                },
                {
                    type: 'checkbox',
                    label: 'editor.show_overlay_image',
                    default: false,
                    name: 'showOverlay',
                },
                {
                    type: 'checkbox',
                    label: 'editor.show_zones',
                    default: false,
                    name: 'showZones',
                },
                {
                    type: 'select',
                    label: 'editor.zone_list',
                    default: '',
                    name: 'zoneList',
                    multiple: true,
                    width: '100%',
                    options: [],
                },
            ],
        },
        {
            label: 'editor.legend_map',
            name: 'legendMap',
            icon: 'pin_drop',
            options: [
                {
                    type: 'checkbox',
                    label: 'editor.show_legend',
                    default: false,
                    name: 'showLegend',
                },
                {
                    type: 'number',
                    label: 'editor.font_size',
                    name: 'fontSize',
                    default: 12,
                    width: '100%',
                },
                {
                    type: 'select',
                    label: 'editor.align',
                    default: 'start',
                    name: 'align',
                    width: '100%',
                    options: [
                        { name: 'events.start', value: 'start' },
                        { name: 'editor.center', value: 'center' },
                        { name: 'events.end', value: 'end' },
                    ],
                },
            ],
        },
    ],
    forge: [
        {
            label: 'editor.title',
            name: 'title',
            icon: 'format_shapes',
            options: [
                {
                    type: 'checkbox',
                    label: 'datatable.display',
                    default: true,
                    name: 'display',
                },
                {
                    type: 'number',
                    label: 'editor.font_size',
                    name: 'fontSize',
                    default: 18,
                    width: '100%',
                },
                {
                    type: 'select',
                    label: 'editor.align',
                    default: 'center',
                    name: 'align',
                    width: '100%',
                    options: [
                        { name: 'events.start', value: 'start', icon: 'format_align_left' },
                        { name: 'editor.center', value: 'center', icon: 'format_align_center' },
                        { name: 'events.end', value: 'end', icon: 'format_align_right' },
                    ],
                },
            ],
        },
        {
            label: '2D/3D',
            name: 'forge',
            icon: 'view_in_ar',
            options: [
                {
                    type: 'select',
                    label: 'editor.model_use',
                    default: '',
                    name: 'modelList',
                    width: '100%',
                    options: [],
                },
                {
                    type: 'checkbox',
                    label: 'editor.show_zones',
                    default: true,
                    name: 'showZones',
                },
                {
                    type: 'select',
                    label: 'editor.zone_list',
                    default: '',
                    name: 'zoneList',
                    multiple: true,
                    width: '100%',
                    options: [],
                },
            ],
        },
    ],
    planning3D: [
        {
            label: 'editor.title',
            name: 'title',
            icon: 'format_shapes',
            options: [
                {
                    type: 'checkbox',
                    label: 'datatable.display',
                    default: true,
                    name: 'display',
                },
                {
                    type: 'number',
                    label: 'editor.font_size',
                    name: 'fontSize',
                    default: 18,
                    width: '100%',
                },
                {
                    type: 'select',
                    label: 'editor.align',
                    default: 'center',
                    name: 'align',
                    width: '100%',
                    options: [
                        { name: 'events.start', value: 'start', icon: 'format_align_left' },
                        { name: 'editor.center', value: 'center', icon: 'format_align_center' },
                        { name: 'events.end', value: 'end', icon: 'format_align_right' },
                    ],
                },
            ],
        },
        {
            label: 'Planning 3D',
            name: 'planning3D',
            icon: 'view_in_ar',
            options: [
                {
                    type: 'select',
                    label: 'editor.planning_use',
                    default: '',
                    name: 'planning',
                    width: '100%',
                    options: [],
                },
                {
                    type: 'select',
                    label: 'editor.task_use',
                    default: '',
                    name: 'tasks',
                    multiple: true,
                    width: '100%',
                    options: [],
                },
                // {
                //     type: 'checkbox',
                //     label: 'editor.show_zones',
                //     default: true,
                //     name: 'showZones',
                // },
                // {
                //     type: 'checkbox',
                //     label: 'editor.show_zones',
                //     default: true,
                //     name: 'showZones',
                // },
                // {
                //     type: 'select',
                //     label: 'editor.zone_list',
                //     default: '',
                //     name: 'display',
                //     multiple: true,
                //     width: '100%',
                //     { name: 'editor.previous_task', value: 'start' },
                //     { name: 'editor.center', value: 'center' },
                //     { name: 'editor.end', value: 'end' },
                // },
            ],
        },
    ],
    table: [
        {
            label: 'editor.title',
            name: 'title',
            icon: 'format_shapes',
            options: [
                {
                    type: 'checkbox',
                    label: 'datatable.display',
                    default: true,
                    name: 'display',
                },
                {
                    type: 'number',
                    label: 'editor.font_size',
                    name: 'fontSize',
                    default: 18,
                    width: '100%',
                },
                {
                    type: 'select',
                    label: 'Position',
                    default: 'top',
                    name: 'position',
                    width: '100%',
                    options: [
                        { name: 'geometry.top', value: 'top' },
                        { name: 'geometry.bottom', value: 'bottom' },
                    ],
                },
                {
                    type: 'select',
                    label: 'editor.align',
                    default: 'center',
                    width: '100%',
                    name: 'align',
                    options: [
                        { name: 'events.start', value: 'start' },
                        { name: 'editor.center', value: 'center' },
                        { name: 'events.end', value: 'end' },
                    ],
                },
                // {
                //     type: "color",
                //     label: "Font color",
                //     default: "#000000",
                //     width: "130px",
                //     name: "fontColor"
                // },
                // {
                //     type: "color",
                //     label: "Background color",
                //     default: "#FFFFFF",
                //     width: "140px",
                //     name: "bgColor"
                // },
            ],
        },
        {
            label: 'editor.headers',
            name: 'header',
            icon: 'view_headline',
            options: [
                {
                    type: 'number',
                    label: 'editor.font_size',
                    name: 'valueFontSize',
                    default: 14,
                    width: '100%',
                },
                {
                    type: 'number',
                    label: 'editor.header_height',
                    name: 'height',
                    default: 48,
                    width: '100%',
                },
                {
                    type: 'select',
                    label: 'editor.align',
                    default: 'start',
                    name: 'align',
                    width: '100%',
                    options: [
                        { name: 'events.start', value: 'start', icon: 'format_align_left' },
                        { name: 'editor.center', value: 'center', icon: 'format_align_center' },
                        { name: 'events.end', value: 'end', icon: 'format_align_right' },
                    ],
                },
                // {
                //     type: "color",
                //     label: "Font color",
                //     default: "#000000",
                //     width: "130px",
                //     name: "fontColor"
                // },
                // {
                //     type: "color",
                //     label: "Background color",
                //     default: "#FFFFFF",
                //     width: "130px",
                //     name: "bgColor"
                // },
            ],
        },
        {
            label: 'editor.cell',
            name: 'cell',
            icon: 'grid_on',
            options: [
                {
                    type: 'number',
                    label: 'editor.font_size',
                    name: 'valueFontSize',
                    default: 14,
                    width: '100%',
                },
                {
                    type: 'number',
                    label: 'editor.cell_height',
                    name: 'height',
                    default: 48,
                    width: '100%',
                },
                {
                    type: 'select',
                    label: 'editor.align',
                    default: 'start',
                    name: 'align',
                    width: '100%',
                    options: [
                        { name: 'events.start', value: 'start' },
                        { name: 'editor.center', value: 'center' },
                        { name: 'events.end', value: 'end' },
                    ],
                },
                // {
                //     type: "color",
                //     label: "Font color",
                //     default: "#000000",
                //     width: "130px",
                //     name: "fontColor"
                // },
                // {
                //     type: "color",
                //     label: "Background color",
                //     default: "#FFFFFF",
                //     width: "130px",
                //     name: "bgColor"
                // },
            ],
        },
        {
            label: 'Group Format',
            name: 'xFormat',
            icon: 'tune',
            options: [
                {
                    type: 'select',
                    label: 'X format',
                    default: 'text',
                    value: 'text',
                    name: 'type',
                    width: '100%',
                    options: [
                        { name: 'editor.string', value: 'text', icon: 'text_fields' },
                        { name: 'editor.number', value: 'number', icon: 'format_list_numbered' },
                        { name: 'form.date', value: 'date', icon: 'calendar_today' },
                        { name: 'editor.timing', value: 'timing', icon: 'schedule' },
                        { name: 'editor.table', value: 'table', icon: 'table_chart' },
                    ],
                },
                {
                    type: 'select',
                    label: 'editor.dateFormat',
                    default: 'YYYY-MM-DD HH:mm:ss',
                    name: 'dateFormat',
                    width: '100%',
                    options: [
                        { name: 'custom', value: 'custom', icon: 'edit' },
                        { name: 'YYYY-MM', value: 'YYYY-MM', icon: 'today' },
                        { name: 'YYYY-MM-DD', value: 'YYYY-MM-DD', icon: 'date_range' },
                        { name: 'YYYY-MM-DD HH', value: 'YYYY-MM-DD HH', icon: 'date_range' },
                        { name: 'YYYY-MM-DD HH:mm', value: 'YYYY-MM-DD HH:mm', icon: 'access_time' },
                        { name: 'YYYY-MM-DD HH:mm:ss', value: 'YYYY-MM-DD HH:mm:ss', icon: 'access_time' },
                        { name: 'ddd HH:mm', value: 'ddd HH:mm', icon: 'schedule' },
                        { name: 'DD HH:mm', value: 'DD HH:mm', icon: 'schedule' },
                    ],
                },
                {
                    type: 'number',
                    label: 'editor.font_size',
                    width: '100%',
                    name: 'fontSize',
                    default: 10,
                },
                {
                    type: 'text',
                    label: 'editor.customFormat',
                    name: 'dateCustomFormat',
                    width: '100%',
                },
            ],
        },
        {
            label: 'Value Format',
            name: 'yFormat',
            icon: 'tune',
            options: [
                {
                    type: 'select',
                    label: 'Y format',
                    default: 'text',
                    value: 'text',
                    name: 'format',
                    width: '100%',
                    options: [
                        { name: 'editor.string', value: 'text' },
                        { name: 'editor.number', value: 'number' },
                        { name: 'form.date', value: 'date' },
                        { name: 'editor.timing', value: 'timing' },
                        { name: 'editor.table', value: 'table' },
                    ],
                },
            ],
        },
    ],
    //////////////////////////////////////////
    chart: [
        {
            label: 'editor.colors',
            name: 'colors',
            icon: 'color_lens',
            options: [
                // The switch of the section: off, the default palette.
                {
                    type: 'checkbox',
                    label: 'editor.colors',
                    name: 'display',
                    default: false,
                },
                // {
                //     type: "checkbox",
                //     label: "Color by label",
                //     default: true,
                //     name: "colorByLabel"
                // },
                {
                    type: 'colors',
                    label: 'editor.colors',
                    default: defaultColorsObj,
                    name: 'colorList',
                },
            ],
        },
        // {
        //     label: "Color",
        //     name: "color",
        //     options: [
        //         {
        //             type: "color",
        //             label: "Background color",
        //             default: "red",
        //             name: "backgroundColor"
        //         },
        //     ]
        // },
        {
            label: 'editor.title',
            name: 'title',
            icon: 'format_shapes',
            options: [
                {
                    type: 'checkbox',
                    label: 'datatable.display',
                    default: true,
                    name: 'display',
                },
                {
                    type: 'number',
                    label: 'editor.font_size',
                    name: 'fontSize',
                    default: 18,
                    width: '100%',
                },
                {
                    type: 'select',
                    label: 'Position',
                    default: 'top',
                    name: 'position',
                    width: '100%',
                    options: [
                        { name: 'geometry.top', value: 'top' },
                        { name: 'geometry.bottom', value: 'bottom' },
                    ],
                },
                {
                    type: 'select',
                    label: 'editor.align',
                    default: 'center',
                    width: '100%',
                    name: 'align',
                    options: [
                        { name: 'events.start', value: 'start' },
                        { name: 'editor.center', value: 'center' },
                        { name: 'events.end', value: 'end' },
                    ],
                },
            ],
        },
        {
            label: 'Legend',
            name: 'legend',
            icon: 'legend_toggle',
            options: [
                {
                    type: 'checkbox',
                    label: 'datatable.display',
                    default: true,
                    width: '110px',
                    name: 'display',
                },
                {
                    type: 'checkbox',
                    label: 'editor.usePoint',
                    default: true,
                    width: '150px',
                    name: 'usePointStyle',
                },
                {
                    type: 'number',
                    label: 'editor.font_size',
                    name: 'fontSize',
                    default: 12,
                    width: '100%',
                },
                {
                    type: 'select',
                    label: 'Position',
                    default: 'right',
                    name: 'position',
                    width: '100%',
                    options: [
                        { name: 'geometry.top', value: 'top' },
                        { name: 'geometry.right', value: 'right' },
                        { name: 'geometry.bottom', value: 'bottom' },
                        { name: 'geometry.left', value: 'left' },
                    ],
                },
                {
                    type: 'select',
                    label: 'editor.align',
                    default: 'start',
                    name: 'align',
                    width: '100%',
                    options: [
                        { name: 'events.start', value: 'start' },
                        { name: 'editor.center', value: 'center' },
                        { name: 'events.end', value: 'end' },
                    ],
                },
            ],
        },
        {
            label: 'editor.xAxis',
            name: 'xAxis',
            icon: 'line_axis',
            options: [
                {
                    type: 'checkbox',
                    label: 'datatable.display',
                    name: 'display',
                    default: true,
                },
                {
                    type: 'text',
                    label: 'editor.customText',
                    name: 'title',
                    width: '100%',
                },
                {
                    type: 'select',
                    label: 'Format',
                    default: 'text',
                    value: 'text',
                    name: 'format',
                    width: '100%',
                    options: [
                        { name: 'editor.string', value: 'text' },
                        { name: 'editor.number', value: 'number' },
                        { name: 'form.date', value: 'date' },
                        { name: 'Timing', value: 'timing' },
                    ],
                },
                {
                    type: 'checkbox',
                    label: 'editor.showEmptyDates',
                    name: 'emptyDate',
                    default: true,
                },
                {
                    type: 'select',
                    label: 'editor.dateFormat',
                    default: 'YYYY-MM-DD HH:mm:ss',
                    name: 'dateFormat',
                    width: '100%',
                    options: [
                        { name: 'custom', value: 'custom', icon: 'edit' },
                        { name: 'YYYY-MM', value: 'YYYY-MM', icon: 'today' },
                        { name: 'YYYY-MM-DD', value: 'YYYY-MM-DD', icon: 'date_range' },
                        { name: 'YYYY-MM-DD HH', value: 'YYYY-MM-DD HH', icon: 'date_range' },
                        { name: 'YYYY-MM-DD HH:mm', value: 'YYYY-MM-DD HH:mm', icon: 'access_time' },
                        { name: 'YYYY-MM-DD HH:mm:ss', value: 'YYYY-MM-DD HH:mm:ss', icon: 'access_time' },
                        { name: 'ddd HH:mm', value: 'ddd HH:mm', icon: 'schedule' },
                        { name: 'DD HH:mm', value: 'DD HH:mm', icon: 'schedule' },
                    ],
                },
                {
                    type: 'number',
                    label: 'editor.font_size',
                    width: '100%',
                    name: 'fontSize',
                    default: 10,
                },
                {
                    type: 'text',
                    label: 'editor.customFormat',
                    name: 'dateCustomFormat',
                    width: '100%',
                },
            ],
        },
        {
            label: 'editor.yAxis',
            name: 'yAxis',
            icon: 'line_axis',
            options: [
                {
                    type: 'checkbox',
                    label: 'editor.displayText',
                    name: 'display',
                    default: true,
                },
                {
                    type: 'text',
                    label: 'editor.customText',
                    name: 'title',
                    width: '100%',
                },
                {
                    type: 'select',
                    label: 'Format',
                    default: 'text',
                    value: 'text',
                    name: 'format',
                    width: '100%',
                    options: [
                        { name: 'editor.string', value: 'text' },
                        { name: 'editor.number', value: 'number' },
                        { name: 'form.date', value: 'date' },
                        { name: 'Timing', value: 'timing' },
                    ],
                },
                {
                    type: 'number',
                    label: 'editor.font_size',
                    width: '100%',
                    name: 'fontSize',
                    default: 10,
                },
                {
                    type: 'select',
                    label: 'Type',
                    default: 'linear',
                    name: 'type',
                    width: '100%',
                    options: [
                        { name: 'editor.linear', value: 'linear', icon: 'trending_up' },
                        { name: 'editor.logarithm', value: 'logarithm', icon: 'functions' },
                        { name: 'units.time_range', value: 'time', icon: 'schedule' },
                    ],
                },
                {
                    type: 'checkbox',
                    label: 'editor.useMinMax',
                    default: false,
                    name: 'useMinMax',
                    group: 'minMax',
                    width: '100%',
                    groupKey: true,
                },
                {
                    type: 'number',
                    label: 'editor.minNumber',
                    name: 'min',
                    width: '123px',
                    group: 'minMax',
                },
                {
                    type: 'number',
                    label: 'editor.maxNumber',
                    name: 'max',
                    width: '123px',
                    group: 'minMax',
                },
                {
                    type: 'number',
                    label: 'editor.stepSize',
                    name: 'stepSize',
                    width: '100%',
                },
                {
                    type: 'checkbox',
                    label: 'editor.customOrder',
                    default: false,
                    width: '100%',
                    name: 'enableCustomOrder',
                    group: 'order',
                    groupKey: true,
                },
                {
                    type: 'button',
                    label: 'editor.changeOrder',
                    width: '100%',
                    group: 'order',
                    name: 'customOrder',
                    action: 'changeOrder',
                },
            ],
        },
        {
            label: 'editor.interactivity',
            name: 'interactivity',
            icon: 'touch_app',
            options: [
                // The switch of the section: a click on a point does nothing when off.
                {
                    type: 'checkbox',
                    label: 'editor.interactivity',
                    name: 'display',
                    default: false,
                },
                {
                    type: 'radio',
                    label: 'editor.interactionMode',
                    name: 'interactionMode',
                    width: '100%',
                    default: 'redirection',
                    options: [
                        { name: 'editor.redirection', value: 'redirection' },
                        { name: 'Zoom', value: 'zoom' },
                    ],
                    group: 'interaction',
                    groupKey: true,
                },
                {
                    type: 'select',
                    label: 'editor.redirectionTarget',
                    default: '',
                    name: 'redirectionTarget',
                    width: '100%',
                    options: [
                        { name: 'Timeline', value: 'timeline', icon: "analytics" },
                        { name: 'editor.riskManagement', value: 'risk_management', icon: "gpp_maybe" },
                        { name: 'Viewer Maps', value: 'maps', icon: "map" },
                        { name: 'Forge 3D', value: 'forge', icon: "view_in_ar" },
                    ],
                    group: 'interaction_redirection',
                },
                {
                    type: 'select',
                    label: 'editor.zoomTargetAxis',
                    name: 'zoomTargetAxis',
                    default: '',
                    width: '100%',
                    options: [
                        { name: 'Axis X', value: 'X', icon: 'swap_horiz' },
                        { name: 'Axis Y', value: 'Y', icon: 'swap_vert' },
                    ],
                    group: 'interaction_zoom',
                }
            ]
        },
        {
            label: 'Annotation',
            name: 'annotation',
            icon: 'note_add',
            options: [
                // The switch of the section: off, nothing drawn.
                {
                    type: 'checkbox',
                    label: 'Annotation',
                    name: 'display',
                    default: false,
                },
                {
                    type: 'checkbox',
                    label: 'editor.addLine',
                    name: 'addLine',
                    width: '100%',
                    default: false,
                },
                {
                    type: 'checkbox',
                    label: 'editor.addBox',
                    name: 'addBox',
                    width: '100%',
                    default: false,
                },
                {
                    type: 'text',
                    label: 'Label',
                    name: 'label',
                    width: '100%',
                },
                {
                    type: 'color',
                    label: 'editor.background',
                    default: '#DDDDDD',
                    width: '100%',
                    name: 'backgroundColor',
                },
                {
                    type: 'number',
                    label: 'Min Y',
                    name: 'yMin',
                    width: '100%',
                    default: 1,
                },
                {
                    type: 'number',
                    label: 'Max Y',
                    name: 'yMax',
                    width: '100%',
                    default: 1,
                },
                {
                    type: 'number',
                    label: 'Min X',
                    name: 'xMin',
                    width: '100%',
                    default: 1,
                },
                {
                    type: 'number',
                    label: 'Max X',
                    name: 'xMax',
                    width: '100%',
                    default: 1,
                },
            ],
        },
    ],
    format: [
        {
            label: 'editor.textFormat',
            name: 'textFormat',
            icon: 'format_color_text',
            options: [
                {
                    type: 'checkbox',
                    label: 'editor.displayValue',
                    name: 'display',
                    default: false,
                },
                {
                    type: 'text',
                    label: 'Placeholder',
                    name: 'placeholder',
                    width: '100%',
                    default: '',
                },
                {
                    type: 'number',
                    label: 'editor.font_size',
                    width: '100%',
                    name: 'fontSize',
                    default: 10,
                },
                {
                    type: 'text',
                    label: 'editor.prefix',
                    name: 'prefix',
                    width: '100%',
                    default: '',
                },
                // {
                //     type: "text",
                //     label: "Parse",
                //     name: "prefix",
                //     width: "100%",
                //     default: ""
                // },
                {
                    type: 'text',
                    label: 'editor.suffix',
                    name: 'suffix',
                    width: '100%',
                    default: '',
                },
            ],
        },
        {
            label: 'editor.numberFormat',
            name: 'numberFormat',
            icon: 'format_list_numbered',
            options: [
                {
                    type: 'checkbox',
                    label: 'editor.displayValue',
                    name: 'display',
                    default: true,
                },
                {
                    type: 'checkbox',
                    label: 'editor.percentageValue',
                    name: 'percentage',
                    default: false,
                    width: '100%',
                },
                {
                    type: 'text',
                    label: 'Placeholder',
                    name: 'placeholder',
                    default: '',
                    width: '100%',
                },
                {
                    type: 'number',
                    label: 'editor.font_size',
                    width: '100%',
                    name: 'fontSize',
                    default: 10,
                },
                {
                    type: 'text',
                    label: 'editor.prefix',
                    name: 'prefix',
                    width: '100%',
                    default: '',
                },
                // {
                //     type: "text",
                //     label: "Parse",
                //     name: "prefix",
                //     width: "100%",
                //     default: ""
                // },
                {
                    type: 'text',
                    label: 'editor.suffix',
                    name: 'suffix',
                    width: '100%',
                    default: '',
                },
                {
                    type: 'number',
                    label: 'editor.multiplier',
                    width: '100%',
                    name: 'multiplier',
                    default: 1,
                },
                {
                    type: 'number',
                    label: 'editor.addition',
                    width: '100%',
                    name: 'addition',
                    default: 0,
                },
                {
                    type: 'number',
                    label: 'editor.decimal',
                    width: '100%',
                    name: 'decimal',
                    default: 0,
                },
            ],
        },
        {
            label: 'editor.dateFormat',
            name: 'dateFormat',
            icon: 'today',
            options: [
                {
                    type: 'checkbox',
                    label: 'editor.displayValue',
                    name: 'display',
                    default: true,
                },
                {
                    type: 'text',
                    label: 'Placeholder',
                    name: 'placeholder',
                    default: '',
                    width: '100%',
                },
                {
                    type: 'number',
                    label: 'editor.font_size',
                    width: '100%',
                    name: 'fontSize',
                    default: 10,
                },
                {
                    type: 'select',
                    label: 'editor.dateFormat',
                    default: 'YYYY-MM-DD HH:mm:ss',
                    name: 'dateFormat',
                    width: '100%',
                    options: [
                        { name: 'custom', value: 'custom', icon: 'edit' },
                        { name: 'YYYY-MM', value: 'YYYY-MM', icon: 'today' },
                        { name: 'YYYY-MM-DD', value: 'YYYY-MM-DD', icon: 'date_range' },
                        { name: 'YYYY-MM-DD HH', value: 'YYYY-MM-DD HH', icon: 'date_range' },
                        { name: 'YYYY-MM-DD HH:mm', value: 'YYYY-MM-DD HH:mm', icon: 'access_time' },
                        { name: 'YYYY-MM-DD HH:mm:ss', value: 'YYYY-MM-DD HH:mm:ss', icon: 'access_time' },
                    ],
                },
                {
                    type: 'text',
                    label: 'editor.customFormat',
                    name: 'customDateFormat',
                    width: '100%',
                },
            ],
        },
        {
            label: 'Timing format',
            name: 'timingFormat',
            icon: 'schedule',
            options: [
                {
                    type: 'checkbox',
                    label: 'editor.displayValue',
                    name: 'display',
                    default: true,
                },
                {
                    type: 'text',
                    label: 'Placeholder',
                    name: 'placeholder',
                    default: '',
                    block: true,
                    width: '100%',
                },
                {
                    type: 'number',
                    label: 'editor.font_size',
                    name: 'fontSize',
                    default: 10,
                    width: '100%',
                },
                {
                    type: 'number',
                    label: 'editor.addition',
                    width: '100%',
                    name: 'addition',
                    default: 0,
                },
                {
                    type: 'select',
                    label: 'editor.timeUnit',
                    default: 'second',
                    name: 'timeUnit',
                    width: '100%',
                    options: [
                        { name: 'date.day', value: 'day' },
                        { name: 'date.hour', value: 'hour' },
                        { name: 'date.minute', value: 'minute' },
                        { name: 'date.second', value: 'second' },
                        { name: 'date.millisecond', value: 'millisecond' },
                    ],
                },
                {
                    type: 'select',
                    label: 'editor.timeFormat',
                    default: '1h23m45s',
                    name: 'timeFormat',
                    width: '100%',
                    options: ['1d2h34m56s', '1h23m45s', '1h23m', '1m23s', '123s'],
                },
            ],
        },
    ],
    video: [
        {
            label: 'editor.video',
            name: 'video',
            icon: 'image',
            options: [
                {
                    type: 'radio',
                    label: 'editor.video_type',
                    default: 'url',
                    name: 'type',
                    options: [
                        { name: 'editor.video_from_url', value: 'url' },
                        { name: 'editor.mediastream', value: 'mediastream' },
                        { name: 'editor.youtube', value: 'youtube' },
                    ],
                    width: '100%',
                    group: 'video',
                    groupKey: true,
                },
                {
                    label: "editor.video_room",
                    name: "room",
                    type: "text",
                    width: '100%',
                    group: 'video_mediastream',
                },
                {
                    label: "editor.video_broadcaster",
                    name: "broadcaster",
                    type: "text",
                    width: '100%',
                    group: 'video_mediastream',
                },
                {
                    label: "editor.video_url",
                    name: "url",
                    type: "text",
                    width: '100%',
                    group: 'video_url',
                },
                {
                    label: "editor.video_url",
                    name: "url",
                    type: "text",
                    width: '100%',
                    group: 'video_youtube',
                },
                {
                    label: "editor.format",
                    name: "format",
                    value: "video/mp4",
                    placeholder: "video/mp4",
                    type: "text",
                    width: '100%',
                    group: 'video_url',
                },
                {
                    type: 'checkbox',
                    label: 'editor.autoplay',
                    default: true,
                    name: 'autoplay',
                }
            ],
        },
        {
            label: 'editor.title',
            name: 'title',
            icon: 'format_shapes',
            options: [
                {
                    type: 'checkbox',
                    label: 'datatable.display',
                    default: true,
                    name: 'display',
                },
                {
                    type: 'number',
                    label: 'editor.font_size',
                    name: 'fontSize',
                    default: 18,
                    width: '100%',
                },
                {
                    type: 'select',
                    label: 'editor.align',
                    default: 'center',
                    name: 'align',
                    options: [
                        { name: 'events.start', value: 'start', icon: 'format_align_left' },
                        { name: 'editor.center', value: 'center', icon: 'format_align_center' },
                        { name: 'events.end', value: 'end', icon: 'format_align_right' },
                    ],
                    width: '100%',
                },
                {
                    type: 'select',
                    label: 'Position',
                    default: 'top',
                    name: 'position',
                    width: '100%',
                    options: [
                        { name: 'geometry.top', value: 'top', icon: 'vertical_align_top' },
                        { name: 'geometry.bottom', value: 'bottom', icon: 'vertical_align_bottom' },
                    ],
                },
            ],
        },
        {
            label: 'editor.imageFormat',
            name: 'imageFormat',
            icon: 'image',
            options: [
                {
                    type: 'radio',
                    label: 'editor.displayMode',
                    name: 'displayMode',
                    default: 'Basic',
                    options: [
                        { name: 'editor.basic', value: 'Basic', icon: 'crop_original' },
                        { name: 'editor.stretched', value: 'Stretched', icon: 'aspect_ratio' },
                    ],
                    width: '100%',
                },
            ],
        },
    ],
    image: [
        {
            label: 'editor.title',
            name: 'title',
            icon: 'format_shapes',
            options: [
                {
                    type: 'checkbox',
                    label: 'datatable.display',
                    default: true,
                    name: 'display',
                },
                {
                    type: 'number',
                    label: 'editor.font_size',
                    name: 'fontSize',
                    default: 18,
                    width: '100%',
                },
                {
                    type: 'select',
                    label: 'editor.align',
                    default: 'center',
                    name: 'align',
                    options: [
                        { name: 'events.start', value: 'start', icon: 'format_align_left' },
                        { name: 'editor.center', value: 'center', icon: 'format_align_center' },
                        { name: 'events.end', value: 'end', icon: 'format_align_right' },
                    ],
                    width: '100%',
                },
                {
                    type: 'select',
                    label: 'Position',
                    default: 'top',
                    name: 'position',
                    width: '100%',
                    options: [
                        { name: 'geometry.top', value: 'top' },
                        { name: 'geometry.bottom', value: 'bottom' },
                    ],
                },
            ],
        },
        {
            label: 'dashboard.manager.auto_refresh',
            name: 'autoRefresh',
            icon: 'autorenew',
            options: [
                {
                    type: 'radio',
                    label: '',
                    name: 'use',
                    default: 'Standart',
                    options: [
                        { name: 'Standard', value: 'Standart' },
                        { name: 'datepicker.customRangeLabel', value: 'Custom' },
                    ],
                    width: '100%',
                    group: 'refresh',
                    groupKey: true,
                },
                {
                    type: 'select',
                    label: 'editor.rateRefresh',
                    default: 'minute',
                    name: 'rateRefresh',
                    options: [
                        { name: 'date.minute', value: 'minute' },
                        { name: 'date.hour', value: 'hour' },
                    ],
                    width: '100%',
                    group: 'refresh_Standart',
                },
                {
                    type: 'number',
                    label: 'editor.y',
                    name: 'value',
                    default: 1,
                    width: '100%',
                    group: 'refresh_Custom',
                },
                {
                    type: 'select',
                    label: 'editor.unitValue',
                    default: 'minute',
                    name: 'unitValue',
                    options: [
                        { name: 'date.second', value: 'seconde' },
                        { name: 'date.minute', value: 'minute' },
                        { name: 'date.hour', value: 'hour' },
                    ],
                    width: '100%',
                    group: 'refresh_Custom',
                },
            ],
        },
        {
            label: 'editor.imageFormat',
            name: 'imageFormat',
            icon: 'image',
            options: [
                {
                    type: 'radio',
                    label: 'editor.displayMode',
                    name: 'displayMode',
                    default: 'contains',
                    options: [
                        { name: 'editor.contains', value: 'contains', icon: 'fit_screen' },
                        { name: 'editor.stretched', value: 'stretched', icon: 'aspect_ratio' },
                        { name: 'editor.cover', value: 'cover', icon: 'fullscreen' },
                    ],
                    width: '100%',
                },
            ],
        },
    ],
    weather: [
        {
            label: 'editor.location',
            name: 'location',
            icon: 'place',
            options: [
                {
                    type: 'text',
                    label: 'editor.city',
                    name: 'city',
                    width: '100%',
                    default: '',
                }
            ]
        },
        {
            label: 'editor.weatherOfTheDay',
            name: 'weatherOfTheDay',
            icon: 'wb_sunny',
            options: [
                {
                    type: 'checkbox',
                    label: 'editor.showWeatherOfTheDay',
                    name: 'showWeatherOfTheDay',
                    default: true,
                    width: '100%',
                    group: 'weatherOfTheDay',
                    groupKey: true,
                },
                {
                    type: 'select',
                    label: 'editor.layout',
                    name: 'layout',
                    default: 'column',
                    options: [
                        { name: 'editor.column', value: 'column', icon: 'view_column' },
                        { name: 'editor.row', value: 'row', icon: 'view_stream' },
                    ],
                    width: '100%',
                    group: 'weatherOfTheDay',
                },
                {
                    type: 'select',
                    label: 'editor.displayOptions',
                    name: 'displayOptions',
                    default: '',
                    multiple: true,
                    options: [
                        { name: 'editor.city', value: 'city', icon: 'place' },
                        { name: 'editor.temperature', value: 'temperature', icon: 'thermostat' },
                        { name: 'editor.icon', value: 'icon', icon: 'image' },
                        { name: 'editor.description', value: 'description', icon: 'description' },
                        { name: 'editor.minMax', value: 'minMax', icon: 'device_thermostat' },
                        { name: 'editor.wind', value: 'wind', icon: 'air' },
                    ],
                    width: '100%',
                    group: 'weatherOfTheDay',
                },
                {
                    type: 'number',
                    label: 'editor.citySize',
                    name: 'citySize',
                    default: 29,
                    width: '100%',
                    group: 'weatherOfTheDay',
                },
                {
                    type: 'number',
                    label: 'editor.tempSize',
                    name: 'tempSize',
                    default: 56,
                    width: '100%',
                    group: 'weatherOfTheDay',
                },
                {
                    type: 'number',
                    label: 'editor.descriptionSize',
                    name: 'descriptionSize',
                    default: 16,
                    width: '100%',
                    group: 'weatherOfTheDay',
                },
                {
                    type: 'select',
                    label: 'editor.extraInfoOptions',
                    name: 'extraInfoOptions',
                    multiple: true,
                    default: [],
                    width: '100%',
                    group: 'weatherOfTheDay',
                    options: [
                        { name: 'editor.humidity', value: 'humidity', icon: 'opacity' },
                        { name: 'editor.precipitation', value: 'precipitation', icon: 'grain' },
                        { name: 'editor.pressure', value: 'pressure', icon: 'compress' },
                        { name: 'editor.UVIndex', value: 'UVIndex', icon: 'sunny' },
                        { name: 'editor.visibility', value: 'visibility', icon: 'visibility' }
                    ],
                }
            ]
        },
        {
            label: 'editor.forecast',
            name: 'forecast',
            icon: 'view_week',
            options: [
                {
                    type: 'radio',
                    label: 'editor.forecastType',
                    name: 'forecastType',
                    options: [
                        { name: 'editor.hourly', value: 'hourly' },
                        { name: 'editor.daily', value: 'daily' },
                        { name: 'editor.none', value: 'none' },
                    ],
                    default: 'hourly',
                    group: 'forecast',
                    groupKey: true,
                },
                //hourly forecast options
                {
                    type: 'checkbox',
                    label: 'editor.icon',
                    name: 'showHourlyIcon',
                    default: true,
                    group: 'forecast_hourly'
                },
                //daily forecast options
                {
                    type: 'number',
                    label: 'editor.daysCount',
                    name: 'daysCount',
                    default: 10,
                    max: 10,
                    min: 2,
                    width: '100%',
                    group: 'forecast_daily',
                },
                {
                    type: 'checkbox',
                    label: 'editor.wind',
                    name: 'showDailyWind',
                    default: true,
                    group: 'forecast_daily'
                },
                {
                    type: 'checkbox',
                    label: 'editor.icon',
                    name: 'showDailyIcon',
                    default: true,
                    group: 'forecast_daily'
                },
                {
                    type: 'checkbox',
                    label: 'editor.minMax',
                    name: 'showMinMax',
                    default: true,
                    group: 'forecast_daily'
                }
            ]
        },
    ]
};
// Every title section (the text one of a block): an icon and a description (the shared rich header of the widgets).
Object.entries(designInputs).forEach(([type, sections]: [string, any[]]) => sections
    .filter(section => section.name === (type === 'block' ? 'text' : 'title') && !section.options.some((option: any) => option.name === 'icon'))
    .forEach(section => section.options.push(
        { type: 'icon', label: 'editor.title_icon', name: 'icon', default: '' },
        { type: 'textarea', label: 'editor.title_description', name: 'description', default: '' },
    )));
